
function footerInMobileView() {
    jQuery('footer').addClass('mobile-footer');
    jQuery('footer .sub-menu').slideUp('slow');
    jQuery('footer .text-2 .textwidget').slideUp('slow');
}

function footerInDesktopView() {
    jQuery('footer').removeClass('mobile-footer');
    jQuery('footer .sub-menu').slideDown('slow');
    jQuery('footer .text-2 .textwidget').slideDown('slow');
}

function removeExpandedClass() {
    jQuery('footer ul li a').removeClass('expanded');
}

jQuery(document).ready(function ($) {
    var viewPort = viewportWidhOnLoad();
    if (viewPort.width <= 768) {

        /*footerInMobileView();*/
        jQuery('footer').addClass('mobile-footer');

    }

    /*click event*/
    $('footer ul.menu > li > a').click(function () {
        if ($('.mobile-footer').length > 0) {
            $('footer .sub-menu').not($(this).next('ul')).slideUp('slow');
            $(this).next('ul').slideToggle('slow');
            $('footer ul li a').not(this).removeClass('expanded');
            $(this).toggleClass('expanded');

            /*for contact menu*/
            $('footer .text-2 .textwidget').slideUp('slow');
            $('footer .text-2 h3').removeClass('expanded');
        }

    });

    /*click event for contact menu*/
    $('footer .text-2 h3').click(function () {
        if ($('.mobile-footer').length > 0){
            $('footer .sub-menu').slideUp('slow');
            $(this).next('div').slideToggle('slow');
            removeExpandedClass();
            $(this).toggleClass('expanded');
        }

    });

    $('html').click(function (e) {

        var container = $("footer ul li, footer ul li a, footer .text-2 h3, footer .text-2 p");
        var containercontact = $("");
        if (!container.is(e.target) && container.has(e.target).length === 0 )
        {
            if(jQuery('footer').hasClass('mobile-footer')){
                footerInMobileView();
                removeExpandedClass();
            }
        }



    });

    /*$("img").one("load", function() {
        console.log('1');
    }).each(function() {
        if(this.complete) $(this).load();
        console.log('3');
    });
    console.log('2');*/


});

jQuery(window).resize(function($){
    var viewPort = viewportWidhOnLoad();

    if (viewPort.width <= 768) {
        if(!jQuery('footer').hasClass('mobile-footer')){
        footerInMobileView();
        removeExpandedClass();
        }
    }else {
        footerInDesktopView();
    }

});


    
